import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MenuMobileSVG } from '../../assets';
import { AuthStateContext } from '../../contexts/AuthContext';
import IconButton from '../IconButton';
import { SoundPillMark } from '../header/draft/SoundPillMark';
import { AppInstallNudge } from './AppInstallNudge';

type MobileSiteHeaderProps = {
  onMenuOpen: () => void;
};

/** lg 미만 — Draft SiteHeader: 설치 넛지 + 모바일 헤더 바 (fixed) */
export function MobileSiteHeader({ onMenuOpen }: MobileSiteHeaderProps) {
  const { t } = useTranslation();
  const { isAuthentication } = useContext(AuthStateContext);

  return (
    <div className="soundpill-mobile-site-header fixed top-0 left-0 right-0 z-50 lg:hidden flex flex-col w-full">
      <AppInstallNudge />
      <header className="soundpill-mobile-site-header__bar px-4 flex justify-between items-center w-full min-h-[var(--mobile-header-bar-height)] gap-2 bg-[#1e1e26]/90 backdrop-blur-md border-b border-[#464555]/50 shrink-0">
        <Link
          to="/app/home"
          className="flex items-center min-w-0 shrink-0 no-underline"
          aria-label={t('header.soundpill')}
        >
          <SoundPillMark />
          <span
            className="ml-[11px] text-[20px] leading-none font-semibold whitespace-nowrap not-italic truncate"
            style={{ letterSpacing: '-0.72px', color: '#E5E2E3' }}
          >
            {t('header.soundpill')}
          </span>
        </Link>
        <div className="flex items-center gap-2 shrink-0">
          {!isAuthentication ? (
            <Link
              to="/auth"
              className="inline-flex items-center justify-center h-8 px-3 rounded-full text-sm font-medium text-white/90 bg-white/10 border border-white/15 no-underline whitespace-nowrap hover:bg-white/15 hover:text-white transition-colors"
            >
              {t('web.login')}
            </Link>
          ) : null}
          <IconButton onClick={onMenuOpen}>
            <MenuMobileSVG />
          </IconButton>
        </div>
      </header>
    </div>
  );
}
